<template>
  <div class="homePage">
    <div
      class="block homeNav"
      ref="headerNavs"
    >
      <headers
        class="herderNav"
        ref="header"
        :isChange="true"
      />
      <el-carousel height="100vh">
        <el-carousel-item
          v-for="(banner, indexer) in bannerList"
          :key="indexer"
        >
          <el-image
            class="rotationImg"
            ref="rotationImg"
            :src="'https://cdn.scoreupup.com' + banner"
            fit="cover"
          >
          </el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <searchNav />
    <!-- 免费公开课，名师零距离 -->
    <div class="backBox">
      <div class="leftCircle wow bounceInUp">
        <img
          class=""
          src="@/assets/home/icon1.png"
        />
      </div>
      <div class="rightCircle wow bounceInUp">
        <img
          class=""
          src="@/assets/home/icon2.png"
        />
      </div>
      <div class="backTitle">免费公开课·名师零距离</div>
      <div class="backContent">
        <div class="wow bounceInUp">
          <img
            class=""
            src="@/assets/home/sggc.png"
            alt="杀G工厂"
            style="position: absolute; z-index: index 999; display: none"
          />
          <img
            class=""
            src="@/assets/home/blue-painting.png"
            style="margin-left: 150px"
          />
        </div>
        <div>
          <div class="Fcontent">
            <div>
              <div class="FreeAdmissionOpenclass">免费公开课</div>
              <div class="soli"></div>
            </div>
            <div class="">
              <ul class="freeText">
                <li>每周轮动开播</li>
                <li>零距离接触名师</li>
                <li>经典技巧+最新真题点题+大师进阶课</li>
              </ul>
            </div>
            <div
              class="appointment"
              @click="nav('open')"
            >马上预约</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页内容 -->
    <div class="homePage">
      <div class="iconRed wow bounce">
        <img
          class=""
          src="@/assets/home/iconred1.png"
        />
      </div>
      <div class="iconRedBottom wow shake">
        <img
          class=""
          src="@/assets/home/iconRed2.png"
        />
      </div>
      <div class="homecontentPran">
        <div class="homecontent">
          <div class="title">
            最新刷题班<span class="ciar">.</span>超高性价比
          </div>
          <div class="neWOpenclass">
            <ul>
              <li>
                <div class="Fcontent">
                  <div>
                    <div
                      class="FreeAdmissionOpenclass"
                      style="color: #ff6c64"
                    >
                      最新刷题班
                    </div>
                    <div
                      class="soli"
                      style="background: #ff6c64"
                    ></div>
                  </div>
                  <div class="text">
                    <dl>
                      <dt><span>·</span><span>每月开营，限定人数</span></dt>
                      <dt>
                        <span>·</span><span>性价比极高的针对性方法训练</span>
                      </dt>
                      <dt>
                        <span>·</span><span>名师领方向+mentor盯进度+群内互帮助</span>
                      </dt>
                    </dl>
                  </div>
                  <div
                    class="appointments"
                    @click="nav('free')"
                  >立即报名</div>
                </div>
              </li>
              <li
                class="wow bounceInRight"
                style="margin-right: 120px"
              >
                <img src="../assets/home/red-bg.png" />
              </li>
            </ul>
          </div>
          <!-- 1v1免费指导 -->
          <div>
            <div
              class="title"
              style="margin-top: 120px"
            >
              1v1 免费指导<span class="ciar">.</span>700+规划
            </div>
            <div class="oneCenter">
              <img
                class="oneLeftImg wow slideInLeft"
                src="../assets/home/oneLeft.png"
                alt=""
              />
              <div class="pinkBox wow slideInRight">
                <div class="pinkTitle">我是萌新考生......</div>
                <div class="row-1">
                  根据我的具体实际情况，帮我针对性地进行规划、提供备考建议，让我对GMAT有了更清晰的认识，更清楚自己的每日学习任务分配，更了解整体的备考思路。
                </div>
                <div class="pinkTitle">我是老司机 (N战考生)......</div>
                <div class="row-1">
                  根据我的esr，分析我的瓶颈问题，帮我指出了知识点上的缺漏、思维上的误区、考试策略上的不足，帮我纠正到了科学正确的备考方向上。
                </div>
                <div
                  @click="hreftwo"
                  class="appointmentPink"
                >免费预约</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 教师团队 -->
    <div class="homecontentPran">
      <div class="homecontent">
        <div
          class="TeacherTeam wow flipInX"
          style="position: relative"
        >
          <div class="title">教师团队<span class="ciar">.</span>试听课</div>
          <swiper
            :options="swiperOption"
            :not-next-tick="notNextTick"
            ref="mySwiper"
            style="margin-top: 58px"
          >
            <swiper-slide
              class="signUpSwiper"
              v-for="(teacher, indexer) in teacherTeams"
              :key="indexer"
            >
              <div class="imgBlack">
                <div class="techitem">
                  <img :src="'https://cdn.scoreupup.com' + teacher.avatar_url" />
                  <!-- <img src="../assets/home/teach1.png" /> -->
                  <div class="introduce">
                    <h3>{{ teacher.nick }}</h3>
                    <div class="nameText">{{ teacher.position }}</div>
                  </div>
                </div>
                <!-- 移入时的变化 -->
                <div class="Techdetails wow bounceInU">
                  <img
                    class="TechdetailsBj"
                    :src="'https://cdn.scoreupup.com' + teacher.teacher_avatar"
                  />
                  <div class="hoverInfo">
                    <div class="flexnav">
                      <img
                        class="toux"
                        :src="
                          'https://cdn.scoreupup.com' +
                          teacher.background_avatar
                        "
                      />
                    </div>
                    <div class="flexnav">
                      <div>{{ teacher.nick }}</div>
                      <div class="nameText">{{ teacher.position }}</div>
                    </div>
                  </div>
                  <div class="Teachcontents">{{ teacher.profile }}</div>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-button-prev"
              style="
                margin-top: 3px;
                margin-left: -25px;
                background-image: url(../assets/accountSeting/PhoneIcon.png);
              "
              slot="button-prev"
            >
              <img
                src="../assets/home/leftIcon.png"
                alt=""
              />
            </div>
            <div
              class="swiper-button-next"
              style="
                margin-top: 3px;
                margin-right: -35px;
                background-image: url(../assets/accountSeting/PhoneIcon.png);
              "
              slot="button-next"
            >
              <img
                src="../assets/home/rightIcon.png"
                alt=""
              />
            </div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 备考平台 -->
    <div class="Testpreparationplatform">
      <div class="oneStopLeft wow bounceInUp">
        <img
          class=""
          src="@/assets/home/oneStopbg2.png"
        />
      </div>
      <div class="oneStopRight wow bounceInUp">
        <img
          class=""
          src="@/assets/home/oneStopbg3.png"
        />
      </div>
      <div class="contes">
        <p class="titlesGAMT">一站式·GMAT备考平台</p>
        <ul class="wow bounce">
          <li
            v-for="(item, index) in team"
            :key="index"
          >
            <div class="Beforehover">
              <img
                :src="'https://cdn.scoreupup.com' + item.picture"
                style="width: 100%"
              />
              <div class="info">
                <div class="titles">{{ item.title }}</div>
                <div style="margin-top: 18px; padding-bottom: 5px">
                  <div
                    class="texts"
                    v-for="(elex, indeles) in item.description"
                    :key="indeles"
                  >
                    {{ elex }}
                  </div>
                </div>
                <div class="download">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="nav(btns[index].url)"
                  >{{ btns[index].tit }}<i class="el-icon-arrow-right"></i></el-link>
                </div>
              </div>
            </div>
            <div class="afterHover">
              <div style="padding-top: 30px">
                <div>{{ item.title }}</div>
                <img
                  class="erweima"
                  :src="'https://cdn.scoreupup.com' + item.qrcode"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 全网推荐  -->
    <div class="Networkwiderecommendation">
      <div style="width: 1250px; margin: 0 auto; height: 100%">
        <div style="min-width: 1250px; height: 800px">
          <div
            class="title"
            style="margin-top: 50px"
          >
            全网好评·<span class="ciar"></span>口碑的力量
          </div>
          <div class="NetContent">
            <swiper
              :options="swiperApp"
              :not-next-tick="notNextTick"
              ref="mySwiper"
              style="margin-top: 58px; width: 1180px"
            >
              <swiper-slide
                class="signUpSwiper"
                v-for="(item, index) in recommend"
                :key="index"
                style="background: none"
              >
                <div><img :src="item.sign" /></div>
                <div style="margin-top: 20px">
                  <img
                    class="iphone"
                    :src="item.phone"
                  />
                </div>
              </swiper-slide>
              <div
                class="swiper-button-prev"
                style="
                  margin-top: 3px;
                  background-image: url(../assets/accountSeting/PhoneIcon.png);
                "
                slot="button-prev"
              >
                <img
                  src="../assets/home/leftIcon.png"
                  alt=""
                />
              </div>
              <div
                class="swiper-button-next"
                style="
                  margin-top: 3px;
                  background-image: url(../assets/accountSeting/PhoneIcon.png);
                "
                slot="button-next"
              >
                <img
                  src="../assets/home/rightIcon.png"
                  alt=""
                />
              </div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <transition name="headerTag_over">
      <rightNav v-if="rightDiv" />
    </transition>
    <div
      class="dataDown"
      v-if="downData"
    >
      <img
        class="dataDownClose"
        src="@/assets/home/closeTagIcon.png"
        alt=""
        @click="closePop"
      />
      <p>王炸资料</p>
      <img
        src="../assets/code.png"
        alt=""
        style="visibility: hidden"
      />
    </div>
  </div>
</template>
<script >
import $ from "jquery";
import api from "../api/home.js";
import headers from "../components/header.vue";
import searchNav from "../components/searchNav.vue";
import API from "@/api/activeTest.js";
import rightNav from "../components/rightNav.vue";
import { WOW } from "wowjs";
let $nb_icon_wrap = $("#nb_icon_wrap");
let $nb_invite_wrap = $("#nb_invite_wrap");
let $nb_nodeboard = $("#nb_nodeboard");
$nb_invite_wrap.css({
  display: "none",
  visibility: "hidden",
});
$nb_icon_wrap.css({
  display: "none",
  visibility: "hidden",
});
$nb_nodeboard.css({
  display: "none",
  visibility: "hidden",
});
export default {
  components: {
    headers,
    searchNav,
    rightNav,
  },
  data() {
    return {
      btns: [
        {
          tit: "免费领取",
          url: "/mostData",
        },
        {
          tit: "立即做题",
          url: "/onlinePractice",
        },
        {
          tit: "马上考试",
          url: "/questionbank",
        },
        {
          tit: "下载机经",
          url: "/freeDown",
        },
        {
          tit: "试听课程",
          url: "/excellentcourse",
        },
      ],
      swiperApp: {
        autoplay: 5000,
        slidesPerView: 5,
        spaceBetween: 30,
        centeredSlides: true,
        loopAdditionalSlides: 100,
        loop: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      swiperOption: {
        autoplay: 3000,
        // speed:1000,
        loop: true,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 4,
        // loop:true,
        // delay: 1000
      },
      // 训练营
      recommend: [
        {
          sign: require("@/assets/home/zhihu.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/bibili.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/weibo.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/wx.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/xiaohongshu.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/zhihu.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/bibili.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/weibo.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/wx.png"),
          phone: ``,
        },
        {
          sign: require("@/assets/home/xiaohongshu.png"),
          phone: ``,
        },
      ],
      rightDiv: false,
      subscribe: false, //免费预约弹窗
      navCodes: require("@/assets/login/whiteCode.png"),
      teacherInfo: false,
      downData: false, //下载资料弹窗
      //Banner
      bannerList: [],
      //教师团队
      teacherTeams: [],
      //全网推荐
      recommends: [],
      //备考平台
      team: [],
      notNextTick: true,
      //swiper
      teacherAnswer: {
        autoplay: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 1,
      },
      //推荐弹窗
      commendPop: false,
      commendInfos: {},
      openClassList: [],
      freeList: [],
      // open:false,
      // contentHeight: 0,
      // mIsOpen:this.value,
      // open:false
    };
  },
  methods: {
    // getseo(){
    //   API.seo().then((res) => {
    //   console.log(res)
    // res.data.title
    // this.openClassList = res.data.data[0];
    // console.log(this.openClassList);
    // })
    // .catch(err => {
    //   this.$message.error('数据获取失败')
    //   })

    // },
    // init () {
    //   this.$nextTick(() => {
    //       this.contentHeight = this.$el.scrollHeight;
    //   });
    //     },
    getClass() {
      API.getOpenClass()
        .then((res) => {
          // console.log(res)
          // res.data.title
          this.openClassList = res.data.data[0];
          console.log(this.openClassList);
          sessionStorage.setItem(
            "openClassList",
            JSON.stringify(this.openClassList)
          );
        })
        .catch((err) => {
          this.$message.error("数据获取失败");
        });
      API.freeClass()
        .then((res) => {
          this.freeList = res.data.data;
          console.log(this.freeList);
          sessionStorage.setItem("freeList", JSON.stringify(this.freeList));
        })
        .catch((err) => {
          this.$message.error("数据获取失败");
        });
    },
    nav(url) {
      if (url === "free") {
        this.$router.push(`/subscribe/2/free/${this.freeList.length - 1}`);
      } else if (url === "open") {
        this.$router.push(`/subscribe/3/open/${this.openClassList.length - 1}`);
      } else {
        this.$router.push(url);
      }

      console.log(url);
    },
    //免费预约 => 显示弹窗
    showPop() {
      this.subscribe = true;
    },
    //免费预约 => 关闭弹窗
    closePopSub() {
      this.subscribe = false;
    },
    goTeacherItem() {
      this.$router.push("/teacherteams");
    },
    //顶部导航
    handleScrollx() {
      let header = this.$refs.header;
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop == 0) {
        header.headerBack.background = "";
        header.herderTits.color = "hsla(0,0%,100%,.8)";
        header.headerIcon = require("@/assets/bottom/bottomIcon.png");
        header.loginButton = {
          backgroundColor: "white",
          color: " rgba(0,0,0,.8)",
        };
        header.isTop = true;
        header.phoneButton = {
          background: "hsla(0,0%,100%,.08)",
          border: "1px solid hsla(0,0%,100%,.8)",
        };
        // this.navCodes = require('@/assets/login/whiteCode.png');
      } else {
        header.isTop = false;
        header.headerBack.background = "#ffffff";
        header.herderTits.color = "#666666";
        header.headerIcon = require("@/assets/home/headerNav.png");
        header.loginButton = {
          background: "#618aff",
          color: "#fff",
        };
        header.phoneButton = {
          color: "#618aff",
          border: "1px solid #618aff",
        };
        // this.navCodes = require('@/assets/login/navCode.png');
      }
      if (scrollTop > 723) {
        this.rightDiv = true;
      } else {
        this.rightDiv = false;
      }
    },
    //一站备考平台按钮
    openDown(i) {
      switch (i) {
        case 0:
          return (this.downData = true);
        case 1:
          return this.$router.push("questionStock");
        case 2:
          return this.$router.push("questionbank");
        case 3:
          return this.$router.push("opportunity");
        default:
          return this.$router.push("springClass");
      }
    },
    //关闭下载资料弹窗
    closePop() {
      this.downData = false;
    },
    //推荐 => 弹窗显示
    shiftCard(infos) {
      this.commendInfos = infos;
      this.commendPop = true;
    },
    //隐藏 => 弹窗
    leaveCard() {
      this.commendPop = false;
    },
    //获取教师列表
    getTeacherList() {
      let params = {
        type: "home",
      };
      let query = this.$qs.stringify(params);
      api
        .getTeacher(query)
        .then((res) => {
          this.teacherTeams = res.data.data;
          console.log(this.teacherTeams);
        })
        .catch((err) => {
          this.$message.error("错误");
        });
    },
    //Banner
    getBanner() {
      let paramss = {
        type: "index",
      };
      let querys = this.$qs.stringify(paramss);
      api
        .getBannerList(querys)
        .then((res) => {
          this.bannerList = res.data.data;
          console.log(this.bannerList);
          // this.carousel()
        })
        .catch((err) => {
          this.$message.error("Banner错误");
        });
    },
    //口碑列表
    getData() {
      this.getBanner();
      this.getTeacherList();
      api.getPublicList().then((res) => {
        this.recommends = res.data.data;
        console.log(this.recommends);
        this.recommends.forEach((item, index) => {
          this.recommend[index].phone = `https://cdn.scoreupup.com${item.img}`;
        });
        console.log(this.recommend);
      });
    },
    //备考平台
    getExam() {
      api.examPlatform().then((res) => {
        if (res.data.code == 0) {
          this.team = res.data.data;
          console.log(this.team);
        }
      });
    },
    carousel() {
      this.$nextTick(() => {
        let ref = this.$refs;
        this.bannerHeight =
          ref.rotationImg && ref.rotationImg.length
            ? ref.rotationImg[0].height
            : "";
        console.log(this.bannerHeight);
      });
    },
    hreftwo() {
      this.$router.push({
        path: "/forref",
      });
    },
  },
  // watch:{
  //       value (newValue) {
  //           this.mIsOpen = newValue;
  //       },
  //       mIsOpen (newValue) {
  //           this.$emit('input', newValue);
  //       }
  // },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  // updated(){
  // this.init()
  // },
  // mounted(){
  //   this.init()
  // },
  mounted() {
    let $nb_icon_wrap = $("#nb_icon_wrap");
    let $nb_invite_wrap = $("#nb_invite_wrap");
    let $nb_nodeboard = $("#nb_nodeboard");
    $nb_invite_wrap.css({
      display: "none",
      visibility: "hidden",
    });
    $nb_icon_wrap.css({
      display: "none",
      visibility: "hidden",
    });
    $nb_nodeboard.css({
      display: "none",
      visibility: "hidden",
    });
    window.addEventListener("scroll", this.handleScrollx);
    window.addEventListener("resize", this.carousel);
    this.getBanner();
    this.getTeacherList();
    this.getData();
    this.getExam();
    // this.getseo()
    this.getClass();
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      });
      wow.init();
    });
    // this.init()
  },
  beforeDestroy() {
    // console.log('销毁');
    window.removeEventListener("scroll", this.handleScrollx);
  },
};
</script>

<style scoped>
@import url("../assets/css/home.css");
</style>



// WEBPACK FOOTER //
// src/view/home.vue